import { NewsService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const newsQueryKey = (congressId: string | undefined) => {
  return ["news", congressId ? congressId : "society"] as const;
};

function useNews(congressId: string | undefined) {
  return useQuery({
    queryKey: newsQueryKey(congressId),
    queryFn: () => NewsService.getAllNews({ congressId, includeFuture: true }),
  });
}

export { newsQueryKey, useNews };
